import React from 'react';
import { FaArrowRight, FaChevronDown } from 'react-icons/fa';

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
};

function Hero() {
    return (
        <section id="home" className="hero">
            {/* Ambient orbs */}
            <div className="hero-orb hero-orb-1" />
            <div className="hero-orb hero-orb-2" />
            <div className="hero-orb hero-orb-3" />
            {/* Dot grid */}
            <div className="hero-grid" />

            <div className="hero-content">
                <div className="hero-badge">
                    <span className="badge-dot" />
                    Sierra Leone's Leading Business Consultancy
                </div>

                <h1>
                    Connecting Africa's<br />
                    Future to{' '}
                    <span className="gradient-text">Global Success</span>
                </h1>

                <p>
                    CONNECT ALL (SL) LTD delivers transformative consulting in business
                    strategy, technology, finance, and capacity building — empowering
                    Sierra Leone's most ambitious organisations.
                </p>

                <div className="hero-buttons">
                    <button
                        className="btn btn-primary btn-lg"
                        onClick={() => scrollTo('services')}
                    >
                        Explore Services <FaArrowRight />
                    </button>
                    <button
                        className="btn btn-outline btn-lg"
                        onClick={() => scrollTo('contact')}
                    >
                        Contact Us
                    </button>
                </div>
            </div>

            <div className="hero-scroll" onClick={() => scrollTo('about')}>
                <div className="hero-scroll-line" />
                <span>Scroll</span>
                <FaChevronDown style={{ fontSize: '0.7rem' }} />
            </div>
        </section>
    );
}

export default Hero;

